import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

function DayLineChart(props) {
    const { days, refSeries, candSeries, refLabel, candLabel, format } = props
    const canvasRef = useRef(null)
    const chartRef = useRef(null)

    const seriesSignature = JSON.stringify({ days, refSeries, candSeries })

    useEffect(() => {
        if (chartRef.current) chartRef.current.destroy()
        const canvasContext = canvasRef.current.getContext("2d", { willReadFrequently: true })
        chartRef.current = new Chart(canvasContext, {
            type: "line",
            data: {
                labels: days,
                datasets: [
                    {
                        label: refLabel,
                        data: refSeries,
                        borderColor: "#a5a5a5",
                        backgroundColor: "#a5a5a5",
                        borderDash: [6, 4],
                        borderWidth: 2,
                        tension: 0.2,
                        pointRadius: 3.5,
                        fill: false
                    },
                    {
                        label: candLabel,
                        data: candSeries,
                        borderColor: "#0b1f82",
                        backgroundColor: "#0b1f82",
                        borderWidth: 2.5,
                        tension: 0.2,
                        pointRadius: 3.5,
                        fill: false
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: format ? {
                        callbacks: { label: (item) => item.dataset.label + ": " + format(item.parsed.y) }
                    } : {}
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: format ? { callback: (value) => format(value) } : {}
                    }
                }
            }
        })
        return () => {
            if (chartRef.current) chartRef.current.destroy()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seriesSignature, refLabel, candLabel])

    return (
        <div style={{ height: "260px" }}>
            <canvas ref={canvasRef} />
        </div>
    )
}

export default DayLineChart
